import trae from 'trae'
import configService from './config'

const apiAlegraStoresService = trae.create({
  baseUrl: configService.apiUrl()
})

export default apiAlegraStoresService
